import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditTicket } from "../../../UI/Advertising/ticket/edit";

const EditTicketPanel = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    subject: "",
    count_ticket_send: "",
    report_url: null,
    status: "",
  });

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.TicketsAdvertising.GetOne}${id}`,
      });

      if (response) {
        setData({
          subject: response.data.subject || "",
          count_ticket_send: response.data.count_ticket_send || "",
          report_url: response.data.report_url || null,
          status: response.data.status || null,
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit ticket <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit ticket: {data?.subject}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditTicket data={data} setData={setData} />
          )
        }
      />
    </div>
  );
};

export default React.memo(EditTicketPanel);
